import { API_CONFIG } from './config';

type AiAnalyticsBaseKind = 'api' | 'root';

const trimTrailingSlashes = (value: string) => value.replace(/\/+$/, '');

export const getAiAnalyticsBaseUrl = (kind: AiAnalyticsBaseKind = 'api'): string => {
  const configuredBase = trimTrailingSlashes(String(API_CONFIG.AI_ANALYTICS_BASE_URL || ''));
  const hasApiSuffix = /\/api$/i.test(configuredBase);

  if (kind === 'root') {
    return hasApiSuffix ? configuredBase.replace(/\/api$/i, '') : configuredBase;
  }

  return hasApiSuffix ? configuredBase : `${configuredBase}/api`;
};

export const getAiAnalyticsUrl = (path: string, kind: AiAnalyticsBaseKind = 'api'): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${getAiAnalyticsBaseUrl(kind)}${normalizedPath}`;
};
